"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _threeIdProviderProxy = _interopRequireDefault(require("./threeIdProviderProxy.js"));

var _postmsgRpc = require("postmsg-rpc");

var IDENTITY_WALLET_IFRAME_URL = 'https://connect.3box.io/';
var HIDE_IFRAME_STYLE = 'width:0; height:0; border:0; border:none !important';
var DISPLAY_IFRAME_STYLE = 'border:none border:0; z-index: 999999; position: fixed;';

var hide = function hide(iframe) {
  return function () {
    return iframe.style = HIDE_IFRAME_STYLE;
  };
};

var display = function display(iframe) {
  return function () {
    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '100%';
    var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '0';
    return iframe.style = "".concat(DISPLAY_IFRAME_STYLE, " width: ").concat(width, "; height: ").concat(height, "; top: ").concat(top, "; left: ").concat(left, ";");
  };
};
/**
 *  ThreeIdConnect provides interface for loading and instantiating IDW iframe,
 *  and provides a 3ID provider interface to send requests to iframe. Acts like
 *  rpc client.
 */


var ThreeIdConnect =
/*#__PURE__*/
function () {
  /**
    *  Creates ThreeIdConnect. Create and loads iframe. Should be instantiated
    *  on page load.
    *
    * @param     {String}    iframeUrl   iframe url, defaults to 3id-connect iframe service
    */
  function ThreeIdConnect(iframeUrl) {
    var _this = this;

    (0, _classCallCheck2.default)(this, ThreeIdConnect);

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      throw new Error('ThreeIdConnect not supported in this enviroment');
    }

    this.iframe = document.createElement('iframe');
    this.iframe.src = iframeUrl || IDENTITY_WALLET_IFRAME_URL;
    this.iframe.style = HIDE_IFRAME_STYLE;
    this.iframe.frameBorder = 0;
    this.iframeLoadedPromise = new Promise(function (resolve, reject) {
      _this.iframe.onload = function () {
        resolve();
      };
    });
    document.body.appendChild(this.iframe);
  }
  /**
    *  Handlers to consumer message to hide or display iframe
    *
    * @private
    */


  (0, _createClass2.default)(ThreeIdConnect, [{
    key: "_registerDisplayHandlers",
    value: function _registerDisplayHandlers() {
      (0, _postmsgRpc.expose)('display', display(this.iframe), {
        postMessage: this.postMessage
      });
      (0, _postmsgRpc.expose)('hide', hide(this.iframe), {
        postMessage: this.postMessage
      });
    }
    /**
      *  Returns a 3ID provider, which can send and receive 3ID messages from iframe
      *
      * @return    {ThreeIdProviderProxy}     A 3ID provider
      */

  }, {
    key: "get3idProvider",
    value: function () {
      var _get3idProvider = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.iframeLoadedPromise;

              case 2:
                this.postMessage = this.iframe.contentWindow.postMessage.bind(this.iframe.contentWindow);

                this._registerDisplayHandlers();

                return _context.abrupt("return", new _threeIdProviderProxy.default(this.postMessage));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get3idProvider() {
        return _get3idProvider.apply(this, arguments);
      }

      return get3idProvider;
    }()
  }]);
  return ThreeIdConnect;
}();

var _default = ThreeIdConnect;
exports.default = _default;